<template>
    <div class="appWrapper">
    <div class="holder">
        <div class="thankyouWrapper">
            <h3>Thank you</h3>
            <p>Thank you for your interest in the Nissan Adventure Club experience! We look forward to seeing you there.</p>
            <!-- <p>Please check you inbox for details and changes to the booking.</p> -->
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
    return {

    };
  }
};
</script>

<style>

</style>